
import { Component, Vue, Prop } from 'vue-property-decorator'

interface Options {
  title?: string
  desc?: string
}

@Component
export default class RegisterWrapper extends Vue {
  @Prop({ type: String, default: '欢迎注册数说故事账号' }) title!: string
  // eslint-disable-next-line no-magic-numbers
  currentYear = 2018

  currentComponent = 'RegisterSuccess'

  steps: Options[] = [
    {
      title: '选择账号类型',
    },
    {
      title: '注册账号',
    },
  ]

  get current() {
    switch (this.$route.name) {
      case 'ModeSelect':
        return 0
      case 'AccountDetail':
        // eslint-disable-next-line no-magic-numbers
        return 1
      case 'Certificate':
        // eslint-disable-next-line no-magic-numbers
        return 2
      default:
        return ''
    }
  }

  mounted() {
    this.currentYear = new Date().getFullYear()
  }
}
